document.addEventListener('DOMContentLoaded', function() {
  const newsletterForms = document.querySelectorAll('.signup-form');
  
  newsletterForms.forEach(form => {
    initNewsletterForm(form);
  });
  
  function initNewsletterForm(form) {
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const errorSpan = form.querySelector('.error-message');
    const successSpan = form.querySelector('.success-message');
    
    let isLoading = false;
    let errorMessage = '';
    let errorMessageShow = false;
    let successMessage = '';
    let successMessageShow = false;
    
    async function getCaptchaToken() {
      return new Promise((resolve) => {
        if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
          grecaptcha.ready(() => {
            const siteKey = document.querySelector('meta[name="shopify-recaptcha-site-key"]')?.content;
            if (siteKey) {
              grecaptcha.execute(siteKey, { action: 'newsletter_signup' }).then(resolve);
            } else {
              resolve(null);
            }
          });
        } else {
          resolve(null);
        }
      });
    }
    
    function validateEmail(email) {
      if (!email) {
        errorMessage = "Enter email";
        return false;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        errorMessage = "Enter a valid email";
        return false;
      }
      
      errorMessage = "";
      return true;
    }
    
    function updateUI() {
      submitButton.disabled = isLoading;
      submitButton.setAttribute('aria-busy', isLoading);
      
      if (errorSpan) {
        if (errorMessageShow) {
          errorSpan.classList.add('show');
        } else {
          errorSpan.classList.remove('show');
        }
        errorSpan.textContent = errorMessage;
      }
      
      if (successSpan) {
        if (successMessageShow) {
          successSpan.classList.add('show');
        } else {
          successSpan.classList.remove('show');
        }
        const textSpan = successSpan.querySelector('.success-text');
        textSpan.textContent = successMessage;
      }
      
      if (errorMessageShow) {
        emailInput.classList.add('input-validate');
      } else {
        emailInput.classList.remove('input-validate');
      }
    }
    
    async function submitForm() {
      const action = form.dataset.action || '/contact';
      const email = emailInput.value.trim();
      
      
      if (!validateEmail(email)) {
        errorMessageShow = true;
        updateUI();
        return;
      }
      
      try {
        isLoading = true;
        updateUI();
        
        const formData = new FormData(form);
        
        const captchaToken = await getCaptchaToken();
        if (captchaToken) {
          formData.append('g-recaptcha-response', captchaToken);
        }
        const response = await fetch(action, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          errorMessageShow = false;
          successMessageShow = true;
          successMessage = form.dataset.successMessage || "Thanks for subscribing!";
          updateUI();
          
          
          emailInput.value = "";
          
          setTimeout(() => {
            successMessageShow = false;
            updateUI();
          }, 12000);
        } else {
          const errorData = await response.text();
          console.error('Subscription failed:', response.status, errorData);
          
          if (response.status === 429) {
            errorMessage = "Too many requests. Please wait 30 seconds before trying again.";
            errorMessageShow = true;
            submitButton.disabled = true;
            emailInput.disabled = true;
            updateUI();
            
            setTimeout(() => {
              submitButton.disabled = false;
              emailInput.disabled = false;
              errorMessageShow = false;
              updateUI();
            }, 30000);
            
          } else if (errorData.includes('CAPTCHA') || errorData.includes('captcha')) {
            errorMessage = "Please complete the verification. Refreshing page...";
            errorMessageShow = true;
            updateUI();
            
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            errorMessage = "Subscription failed. Please try again.";
            errorMessageShow = true;
            updateUI();
          }
        }
        
      } catch (error) {
        console.error('Subscription failed:', error.message);
        
        errorMessage = "Network error. Please try again.";
        errorMessageShow = true;
        updateUI();
      } finally {
        isLoading = false;
        updateUI();
      }
    }
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      submitForm();
    });
    
    emailInput.addEventListener('input', function() {
      if (errorMessageShow && validateEmail(this.value.trim())) {
        errorMessageShow = false;
        updateUI();
      }
      
      if (successMessageShow) {
        successMessageShow = false;
        updateUI();
      }
    });
    
    updateUI();
  }
});
